import ListView from "@/common/custom-lists/ListView";
import { Actions as ADVISOR_ACTIONS } from "@/redux/actions/advisorActions";
import { useEffect, useMemo } from "react";
import { connect } from "react-redux";
import ScheduledTaskRow from "./ScheduledTaskRow";
import { orderBy, uniqBy } from "lodash";
import ReactSelect from "react-select";
import { useQuery } from "@/components/common/helpers/ReactHooks";

const scheduledTaskStatusOptions = ["Pending", "Success", "Processing", "Cancelled", "Failed", "Skipped", "Redundant"].map((value) => ({
	label: value,
	value,
}));

const ScheduledTasks = ({ scheduledTasks, getScheduledTasks, organisations }) => {
	const columns = ["Company", "Entity", "Action", "Due", "Status", { hidden: true }];
	const [company, setCompany] = useQuery("company");
	const [status, setStatus] = useQuery("status", "Pending");

	const filteredTasks = useMemo(() => {
		// filter by company amd status if any are set
		return scheduledTasks?.filter((p) => {
			const companyMatch = company ? p.org == company : true;
			const statusMatch = status ? p.status == status : true;
			return companyMatch && statusMatch;
		});
	}, [scheduledTasks, status, company]);

	useEffect(() => {
		getScheduledTasks();
	}, []);

	return (
		<>
			<div className="content bg-gray-lighter">
				<div className="row">
					<div className="col-sm-12">
						<div className="pull-left">
							<h1 className="page-heading">Scheduled Tasks</h1>
						</div>
					</div>
				</div>
			</div>
			<div className="clearfix" />
			<div className="content bg-white">
				<div className="block-header pr-0 pl-0">
					<div
						className="pull-right"
						style={{ width: 250 }}
					>
						<div className="form-material">
							<ReactSelect
								isClearable
								options={scheduledTaskStatusOptions}
								styles={{
									menu: (provided) => ({ ...provided, zIndex: 10 }),
								}}
								value={scheduledTaskStatusOptions?.find((o) => o.value == status)}
								onChange={(selected) => {
									setStatus(selected?.value || null);
								}}
							/>
							<label>Status</label>
						</div>
					</div>
					<div
						className="pull-right"
						style={{ width: 250, marginRight: "1rem" }}
					>
						<div className="form-material">
							<ReactSelect
								isClearable
								options={organisations}
								styles={{
									menu: (provided) => ({ ...provided, zIndex: 10 }),
								}}
								value={organisations?.find((o) => o.value == company)}
								onChange={(selected) => {
									setCompany(selected?.value || null);
								}}
							/>
							<label>Organisation</label>
						</div>
					</div>
				</div>
				<ListView
					{...{
						actionColumn: false,
						title: `Tasks ${status || "Scheduled"}`,
						items: filteredTasks?.map((task) => (
							<ScheduledTaskRow
								key={task.id}
								task={task}
								// view={view?.value}
							/>
						)),
						columns,
					}}
				/>
			</div>
		</>
	);
};

const mapStateToProps = (state) => {
	const { scheduledTasks } = state.advisors || {};

	const organisations = uniqBy(scheduledTasks || [], "org")?.map((p) => ({ label: p.companyName, value: p.org }));

	return {
		organisations: orderBy(organisations || [], "label", "asc"),
		scheduledTasks: orderBy(scheduledTasks || [], "date", "asc"),
		isAdmin: state.my.profile.isAdmin,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getScheduledTasks: () => dispatch(ADVISOR_ACTIONS.getScheduledTasks()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ScheduledTasks);
